<div [ngClass]="'form-editor'">
    <dx-text-area [attr.id]="'input-' + element.ElementID" type="text" autocomplete="off" [(value)]="inputValue" [autoResizeEnabled]="true"
                  [maxLength]="element.MaxLength"
                  [minHeight]="120" [maxHeight]="480" (onValueChanged)="valueChanged($event)" [disabled]="inputFormGroup.get('value')?.disabled"
                  [(isValid)]="renderingInformation.validationInformation.valid"
                  [(validationError)]="renderingInformation.validationInformation.validationMessage"
                 [placeholder]="element.NullText ?? ''"></dx-text-area>
</div>
